import moment from 'moment';
import { useLoadRange } from './useLoadRange';

export function useLoadRangeAtTs() {
  const setStreamRange = useLoadRange();

  return (fromTs: number) => {
    const _from = moment(fromTs);
    const _to = _from.clone().add(1, 'hour');

    return setStreamRange(_from.valueOf(), _to.valueOf());
  };
}
